module.exports = "/images/icon_social_insta_yellow.png?367de300101c4447f469d9ddfeef054b";